import { getCloudEnvironmentDiscoverer } from '../discovery/getCloudEnvironmentDiscoverer';
import { getCloudEnvironmentStorage } from '../storage/getCloudEnvironmentStorage';
import type { CloudEnvironmentResolver } from '../types/CloudEnvironmentResolver';
import { CloudEnvironmentResolverImpl } from './CloudEnvironmentResolverImpl';

let cloudEnvironmentResolver: Promise<CloudEnvironmentResolver>;

export async function getCloudEnvironmentResolver(): Promise<CloudEnvironmentResolver> {
    if (!cloudEnvironmentResolver) {
        cloudEnvironmentResolver = getCloudEnvironmentResolverImpl();
    }

    return cloudEnvironmentResolver;
}

async function getCloudEnvironmentResolverImpl(): Promise<CloudEnvironmentResolver> {
    const storage = await getCloudEnvironmentStorage();
    const discoverer = await getCloudEnvironmentDiscoverer();
    return new CloudEnvironmentResolverImpl(storage, discoverer);
}
